import React from 'react';
import Geosuggest from 'react-geosuggest';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import _ from "underscore";
import Select from 'react-select';
import { translate } from 'react-i18next';

export function generateFicheInputs(prop, input, disabled = false, address = false, datalist = false, cb = null, visible = true, addon = false, masked = false, t) {
	var input;

	if (address) {
		var { city, place_id, cp, gps } = address
	}

	var color = 'color' in input ? input.color : '#000';

	// Utiliser translationKey si défini, sinon input.name
	var translationKey = input.translationKey || input.name;

	// Traduire le help si disponible
	var helpText;
	if (t) {
		var translatedHelp = t('productFormInputs.'+translationKey+'_help');
		helpText = (translatedHelp && translatedHelp !== 'productFormInputs.'+translationKey+'_help') ? translatedHelp : (input.help || '');
	} else {
		helpText = input.help || '';
	}

	const tooltip = (
		<Tooltip id="tooltip"><strong>{helpText}</strong></Tooltip>
	);

	var help = helpText != '' ? (
		<span className="input-group-addon">
			<OverlayTrigger placement="top" overlay={tooltip}>
				<i className="fa fa-info-circle" />
			</OverlayTrigger>
		</span>
	) : '';


	var addonCp = addon != false ? (
		addon
	) : ''

	var inputClass = '';

	if (input.help != '' || addon != false) {
		var className = 'input-group';
	} else {
		var className = '';
	}

	var readOnly = input.readOnly ? input.readOnly : false;


	if (readOnly) {
		disabled = true;
	}

	var requiredStar = input.rules.indexOf('required') > -1 ? <span style={{ fontSize: '18px' }}>*</span> : ''

	// Utiliser la traduction basée sur translationKey (ou input.name)
	var labelText;
	if (t) {
		var translatedLabel = t('productFormInputs.'+translationKey);
		// Si la traduction retourne la clé elle-même (non trouvée), utiliser input.label comme fallback
		labelText = (translatedLabel && translatedLabel !== 'productFormInputs.'+translationKey) ? translatedLabel : (input.label || input.name);
	} else {
		labelText = input.label || input.name;
	}
	var label = <label style={{ color: color }} for={input.name} className="control-label">{labelText} {requiredStar}</label>

	var helpBlock = <div className="help-block">{prop.error}</div>

	if (cb) {
		var cbProps = {}
		cbProps[cb.type] = cb['func']
		cbProps['onMouseEnter'] = cb['func']
		cbProps['onMouseLeave'] = cb['func']
	} else {
		var cbProps = null
	}

	if (input.type == 'text' || input.type == 'password') {
		if (datalist) {
			var datalistHTML = []
			_.each(datalist, (data) => {
				datalistHTML.push(<option value={data.identification_GSM} />)
			})
			var list = "list"
			datalistHTML = <datalist id='list'>{datalistHTML}</datalist>
		} else {
			var datalistHTML = ''
			var list = false
		}

		input = (
			<div key={'input' + input.name} className={'form-group' + (prop.error ? ' has-error' : '')}>
				{label}
				<div className={inputClass}>
					<div className={className}>
						<input id={input.name} list={list} type={input.type}
							disabled={disabled} className="col-xs-8 form-control" placeholder={input.placeholder || ""} {...prop}
							{...cbProps}
						/>
						{addonCp}
						{help}
						{datalistHTML}

					</div>
				</div>
				{prop.error && helpBlock}
			</div>
		);
	} else if (input.type == 'boolean') {
		input = (
			<div key={'input' + input.name} className={'form-group' + (prop.error ? ' has-error' : '')}>
				{label}
				<div className={inputClass}>
					<div className={className}>
						<select id={input.name} className="form-control" disabled={disabled}
							{...prop}
							// required syntax for reset form to work
							// undefined will not change value to first empty option
							// when resetting
							value={prop.value || ''}>
							<option></option>
							<option value="1">{t('main.yes')}</option>
							<option value="0">{t('main.no')}</option>
						</select>
						{help}
					</div>
				</div>
				{prop.error && helpBlock}
			</div>
		)

	} else if (input.type == 'hidden') {
		input = (
			<div style={{ display: 'none' }} key={'input' + input.name} className={'form-group' + (prop.error ? ' has-error' : '')}>
				{label}
				<div className={inputClass}>
					<input type="hidden" className="form-control"  {...prop} />
				</div>
			</div>


		)
	}


	else if (input.type == 'google_address') {
		input = (
			<div className="form-group">
				{label}
				<div className={inputClass}>
					<Geosuggest country="fr" placeHolder=""
						placeholder="Chercher une adresse"
						disabled={disabled}
						onChange={prop.onChange} onSuggestSelect={(address) => {
							if (!address) return prop.onChange(null)
							var ville = address.gmaps['address_components'].filter(function (addr) {
								return (addr.types[0] == 'locality') ? 1 : (addr.types[0] == 'administrative_area_level_1') ? 1 : 0;
							});

							var zip_code = address.gmaps['address_components'].filter(function (addr) {
								return (addr.types[0] == 'postal_code') ? 1 : 0;
							});

							var location = address.location;

							var gps_coords = [location.lat, location.lng].join(',')



							gps.onChange(gps_coords)

							cp.onChange(zip_code[0].long_name);
							place_id.onChange(address.placeId)



							prop.onChange(address.label);
							city.onChange(ville[0].long_name);

						}} {...prop} />

				</div>
				{help}
				{prop.error && helpBlock}
			</div>
		);


	}
	else if (input.type == 'select') {

		var options = [];

		_.each(input.choices, (choice) => {

			if (typeof (choice) == "object") {
				options.push(<option value={choice.value}>{t('productFormInputs.'+choice.label)}</option>)
			} else {
				options.push(<option value={choice}>{choice}</option>)
			}


		})

		input = (
			<div key={'input' + input.name} className={'form-group' + (prop.error ? ' has-error' : '')}>
				{label}
				<div className={inputClass}>
					<div className={className}>
						<select id={input.name} className="form-control" disabled={disabled}
							{...prop}
							// required syntax for reset form to work
							// undefined will not change value to first empty option
							// when resetting
							value={prop.value || ''}>
							{options}
						</select>
						{help}
					</div>
				</div>
				{prop.error && helpBlock}
			</div>
		)
	}

	else if (input.type == 'react-select') {

		var options = [
			{ value: 'one', label: 'One' },
			{ value: 'two', label: 'Two' }
		];

		input =
			<Select
				name="form-field-name"
				value="one"
				options={options}
			/>
	}
	return <div style={{ display: masked ? 'none' : 'block' }} className="form-input">{input}</div>;
}

